// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_KoB","cls2":"SearchBox-cls2_rHk SearchBox-cls1_KoB"};